export const styles = {
  base: 'tw-rounded-full tw-inline-flex tw-items-center tw-gap-1 tw-transition-colors tw-font-medium',
  interactive: 'tw-cursor-pointer',

  // Sizes
  sm: 'tw-text-2xs tw-px-2 tw-py-1',
  md: 'tw-text-xs tw-px-3 tw-py-1.5',

  // Variants (default state)
  primary: 'tw-bg-primary-100 tw-text-primary-700 hover:tw-bg-primary-200',
  secondary: 'tw-bg-secondary-100 tw-text-secondary-700 hover:tw-bg-secondary-200',
  neutral: 'tw-bg-neutral-100 tw-text-neutral-700 hover:tw-bg-neutral-200',

  // Active states
  primaryActive: 'tw-bg-primary-500 tw-text-white hover:tw-bg-primary-600',
  secondaryActive: 'tw-bg-secondary-500 tw-text-white hover:tw-bg-secondary-600',
  neutralActive: 'tw-bg-neutral-500 tw-text-white hover:tw-bg-neutral-600',

  // Count badge
  count: 'tw-min-w-4 tw-h-4 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-text-2xs',
  countDefault: 'tw-bg-primary-700/20',
  countActive: 'tw-bg-white/20',
};
